import React from 'react';
import { AutomationSettings } from './AutomationSettings';
import { useWeatherApi } from '../../context/WeatherApiContext';

export const SettingsView: React.FC = () => {
  const { status, startPolling, stopPolling, isPolling } = useWeatherApi();

  return (
    <div className="p-8 space-y-8" style={{ backgroundColor: '#000000', minHeight: '100vh' }}>
      <h2 className="text-2xl font-semibold">Settings</h2>

      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold mb-4">Weather API Status</h3>
          <div className="glass-card p-6">
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div
                  className={`w-3 h-3 rounded-full ${
                    status.connected ? 'bg-ios-green' : 'bg-gray-500'
                  }`}
                />
                <span className={status.connected ? 'text-ios-green' : 'text-gray-400'}>
                  {status.connected ? 'Connected to Open-Meteo API' : 'Disconnected'}
                </span>
              </div>
              {status.lastFetch && (
                <div className="text-sm text-gray-400">
                  Last fetch: {new Date(status.lastFetch).toLocaleString()}
                </div>
              )}
              {status.error && (
                <div className="p-3 bg-red-500/20 border border-red-500/50 rounded-lg text-sm text-red-300">
                  Error: {status.error}
                </div>
              )}
              <div className="flex gap-2">
                <button
                  onClick={startPolling}
                  disabled={isPolling}
                  className="px-4 py-2 bg-ios-blue text-white rounded-lg hover:bg-ios-blue/80 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Start Polling
                </button>
                <button
                  onClick={stopPolling}
                  disabled={!isPolling}
                  className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Stop Polling
                </button>
              </div>
              <div className="text-xs text-gray-500 mt-2">
                Location: Cabuyao, Laguna, Philippines (14.2786°N, 121.1242°E)
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold mb-4">Automation</h3>
          <AutomationSettings />
        </div>
      </div>
    </div>
  );
};
